import { translate } from "../Services/translation";

export function ExpandableCategoryDescription(){
    var button = document.getElementById("read-more-button");
    var descriptionEle = document.querySelector(".category-page__intro-description");

    var expandableClass = "category-page__intro-description--expandable";
    var expandedClass = "category-page__intro-description--expanded";
    
    if (descriptionEle.clientHeight > 200) {
        descriptionEle.classList.add(expandableClass);
        button.style.display = "block";
        button.innerHTML = translate('category-navigation.show-more');
    
        button.addEventListener("click", function () {
            descriptionEle.classList.toggle(expandedClass);

            if (descriptionEle.classList.contains(expandedClass)) {
                button.innerHTML = translate('category-navigation.show-less');
            } else {
                button.innerHTML = translate('category-navigation.show-more');
            }
        });
    }
}

